import { getRichmenuTemplateImage } from "../assets";

// Re-export for convenience
export { getRichmenuTemplateImage };

import {
	RICHMENU_TEMPLATES_COMPACT,
	RICHMENU_TEMPLATES_LARGE,
	type RichMenuTemplateWithImage,
} from "../../shared/constants/richmenu.constants";

// Utility function to merge template data with image URLs
const addImageUrlToTemplate = (template: any): RichMenuTemplateWithImage => ({
	...template,
	imageUrl: getRichmenuTemplateImage(template.name),
});

// Export templates with image URLs for client use
export const RICHMENU_TEMPLATES_WITH_IMAGES = {
	compact: Object.fromEntries(
		Object.entries(RICHMENU_TEMPLATES_COMPACT).map(([key, template]) => [
			key,
			addImageUrlToTemplate(template),
		]),
	),
	large: Object.fromEntries(
		Object.entries(RICHMENU_TEMPLATES_LARGE).map(([key, template]) => [
			key,
			addImageUrlToTemplate(template),
		]),
	),
};

// Utility functions for client use
export const getAllRichmenuTemplatesWithImages =
	(): RichMenuTemplateWithImage[] => [
		...Object.values(RICHMENU_TEMPLATES_WITH_IMAGES.compact),
		...Object.values(RICHMENU_TEMPLATES_WITH_IMAGES.large),
	];

export const getRichmenuTemplateWithImage = (
	templateName: string,
): RichMenuTemplateWithImage | undefined => {
	const compactTemplate = RICHMENU_TEMPLATES_WITH_IMAGES.compact[templateName];
	const largeTemplate = RICHMENU_TEMPLATES_WITH_IMAGES.large[templateName];

	return compactTemplate || largeTemplate;
};

export const getCompactTemplatesWithImages = (): RichMenuTemplateWithImage[] =>
	Object.values(RICHMENU_TEMPLATES_WITH_IMAGES.compact);

export const getLargeTemplatesWithImages = (): RichMenuTemplateWithImage[] =>
	Object.values(RICHMENU_TEMPLATES_WITH_IMAGES.large);
